<section class="labels-section-wrapper">
	@if (editable()) {
		<span class="select-label">{{ 'labels' | translate }}</span>
	}
	@for (label of selectedLabels() | slice: 0 : size; track label) {
		<label-badge
			[label]="label"
			[showCloseButton]="editable()"
			(closeIconClicked)="deleteLabel(label)"
		/>
	}

	@if (selectedLabels().length > size || !this.labelsCollapsed()) {
		<div class="toggle-button" (click)="toggleLabelsAmount()">
			@if (labelsCollapsed()) {
				<span class="show-more"> +{{ selectedLabels().length - size }} </span>
			}
			@if (!labelsCollapsed()) {
				<span class="show-less">{{ 'show_less' | translate }}</span>
			}
		</div>
	}
	@if (editable()) {
		<button
			mat-mini-fab
			class="surface-fab"
			[matMenuTriggerFor]="labelListMenu"
			(menuClosed)="menuClosedHandler()"
		>
			<mat-icon svgIcon="add"></mat-icon>
		</button>
	}
</section>

<mat-menu #labelListMenu class="label-list-menu" xPosition="after" yPosition="below">
	<div
		class="label-list-menu-template nice-scroll colored-scroll-track visible-scroll"
		(click)="$event.stopPropagation()"
	>
		<label-list-menu
			[selectedLabelPks]="formControl.value"
			(selectedLabelsChange)="onSelectedLabelsChange($event)"
		/>
	</div>
</mat-menu>
